<template>
  <BaseModal
    small
    @close="$emit('close')"
    useForm
    @submit="onSubmit"
  >
    <Flex direction="column">
      <BaseText size="l">
        {{ $t('global.confirmation.confirm_email_amount', {
            item: `${filteredCustomersCount} ${$t(
              'global.items.customer',
              filteredCustomersCount
            )}`
          }) }}
      </BaseText>
      <BaseRadio
        v-if="hasDeliverySchedule"
        v-model="action"
        :label="$t('marketing.email.send-template-modal.label_when')"
        :options="[
          {
            label: $t('marketing.email.send-template-modal.send_template'),
            value: 'send_template'
          },
          {
            label: $t('marketing.email.send-template-modal.save_template'),
            value: 'save_template'
          }
        ]"
        @update:modelValue="onActionOptionSelect"
        v-test="'radioGroupModal'"
      />
      <BaseInput
        v-if="action === 'save_template'"
        v-model="name"
        :label="$t('global.name')"
        required
        v-test="'modalNameInput'"
      />
    </Flex>
    <template #footer>
      <BaseButton
        color="inverted"
        :disabled="isLoading"
        @click="$emit('close')"
        v-test="'send-template-cancel'"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        :loading="isLoading"
        submitForm
        v-test="'send-template-confirm'"
      >
        {{ $t(`global.actions.${action === 'send_template' ? 'send' : 'save'}`) }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia';
import { defineComponent, ref } from 'vue';
import eventBus from '@/event-bus';
import { flash } from '@/helpers/ui';
import { useOnboardingStore } from '@/stores/onboarding';
import { useMarketingStore } from '../store';
import { useMarketingBuilderStore } from '../store/builder';

export default defineComponent({
  emits: ['close'],
  setup() {
    const action = ref('send_template');
    const { currentOnboardingFlow } = storeToRefs(useOnboardingStore());
    const { name, hasDeliverySchedule, isSubmitted } = storeToRefs(
      useMarketingStore(),
    );
    const { createEmailTemplate, updateEmailTemplate, sendMarketingEmail } =
      useMarketingStore();
    const { filteredCustomersCount } = storeToRefs(useMarketingBuilderStore());

    const onActionOptionSelect = (value) => {
      action.value = value;
    };

    return {
      action,
      onActionOptionSelect,
      filteredCustomersCount,
      name,
      hasDeliverySchedule,
      currentOnboardingFlow,
      isSubmitted,
      createEmailTemplate,
      updateEmailTemplate,
      sendMarketingEmail,
    };
  },
  data() {
    return {
      isLoading: false,
      isSubmitting: false,
    };
  },
  methods: {
    onSaveTemplate() {
      this.$router.push({ name: 'marketing-email' });
      flash(this.$t('global.flash.template_saved'));

      if (this.currentOnboardingFlow === 'marketing') {
        eventBus.$emit('open-task-menu');
        this.currentOnboardingFlow = '';
      }
      this.isLoading = false;
    },
    onSubmit() {
      this.isSubmitting = true;

      if (this.action === 'send_template') {
        this.isLoading = true;
        if (this.$route.params.id) {
          this.updateEmailTemplate('MARKETING_CAMPAIGN').then(() => {
            this.sendTemplate();
          });
        } else {
          this.sendTemplate();
        }
      }

      if (this.action === 'save_template') {
        this.isLoading = true;
        if (this.$route.params.id) {
          this.updateEmailTemplate('MARKETING_CAMPAIGN').then(() => {
            this.onSaveTemplate();
          });
        } else {
          this.createEmailTemplate().then(() => {
            this.onSaveTemplate();
          });
        }
      }
    },
    sendTemplate() {
      this.sendMarketingEmail().finally(() => {
        this.$router.push({ name: 'marketing-email' });
        flash(this.$t('global.flash.all_emails_sent'));
        this.isSubmitted = false;
        if (this.currentOnboardingFlow === 'marketing') {
          eventBus.$emit('open-task-menu');
          this.currentOnboardingFlow = '';
        }
        this.isLoading = false;
      });
    },
  },
});
</script>
